import {
  selectActiveChargingModel,
  selectBundlePaymentPlansInitLoading,
  selectMyBundlesInitLoading,
  selectMyBundlesStatusInitLoading,
  selectMySubscriptionsInitLoading,
} from 'domains/account/store/selectors';
import {
  selectHasPromoBundle,
  selectPromoChargingModel,
} from 'modules/referralProgram/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatusTransition } from 'domains/account/hooks/useAccountStatusTransation';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useMenu } from 'modules/common/hooks/useMenu';

export const useBalanceMenuButton = () => {
  const { isLoggedIn } = useAuth();
  const { group, isAccountInitializing } = useAccount();
  const { hasAccountStatusTransition } = useAccountStatusTransition();

  const isMyBundlesStatusLoading = useAppSelector(state =>
    selectMyBundlesStatusInitLoading(state, group),
  );
  const isBundlePaymentPlansLoading = useAppSelector(
    selectBundlePaymentPlansInitLoading,
  );
  const isMyBundlesLoading = useAppSelector(selectMyBundlesInitLoading);
  const isMySubscriptionsLoading = useAppSelector(
    selectMySubscriptionsInitLoading,
  );

  const chargingModel = useAppSelector(state =>
    selectActiveChargingModel(state, group),
  );

  const promoChargingModel = useAppSelector(state =>
    selectPromoChargingModel(state, group),
  );

  const hasPromoBundle = useAppSelector(state =>
    selectHasPromoBundle(state, group),
  );

  const currentChargingModel = hasPromoBundle
    ? promoChargingModel!
    : chargingModel;

  const {
    anchorEl,
    handleClose,
    handleOpen,
    open: isBalanceMenuOpened,
  } = useMenu();

  const { balance: balancesData } = currentChargingModel;

  return {
    anchorEl,
    balance: balancesData.balanceApiCredits,
    balanceInRequests: balancesData.balanceInRequests,
    creditBalance: balancesData.balanceApiCredits,
    currentChargingModel,
    handleClose,
    handleOpen,
    hasStatusTransition: hasAccountStatusTransition,
    isBalanceMenuOpened,
    isLoading:
      isAccountInitializing ||
      isMyBundlesStatusLoading ||
      isBundlePaymentPlansLoading ||
      isMyBundlesLoading ||
      isMySubscriptionsLoading,
    isLoggedIn,
    usdBalance: balancesData.balanceUsd,
  };
};
